import * as React from 'react';

import Pill from 'af-components/Pills/Pill';

import DeleteEmailBody from './DeleteEmailBody';

interface EmailContact {
	id: number;
	email: string;
}

interface OwnProps {
	emailContact: EmailContact;
	selectEmailForEdit: (id: number) => void;
	deleteEmailContact: (id: number) => Promise<void>;
}

type Props = OwnProps;

const EmailPreview: React.FC<Props> = (props) => {

	const {
		emailContact,
		selectEmailForEdit,
		deleteEmailContact,
	} = props;

	const selectForEdit = React.useCallback(() => {
		selectEmailForEdit(emailContact.id);
	}, [emailContact.id, selectEmailForEdit]);

	const handleRemoveEmailContact = React.useCallback(async () => {
		await deleteEmailContact(emailContact.id);
	}, [deleteEmailContact, emailContact.id]);

	const modalBody = React.useCallback((contact: EmailContact) => {
		return <DeleteEmailBody email={contact.email} />;
	}, []);

	return (
		<Pill
			item={emailContact}
			labelKey="email"
			modalBody={modalBody}
			modalTitle="Delete Email"
			onClick={selectForEdit}
			removeItem={handleRemoveEmailContact}
		/>
	);
};

export default React.memo(EmailPreview);
